import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

import { BASE_URL_SETTINGS } from "constants/redirects";

const goToBillingPortal = async () => {
  const functionRef = httpsCallable(
    functions,
    "ext-firestore-stripe-payments-createPortalLink"
  );
  //   functions('us-central1')
  //   .httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink')
  const { data }: any = await functionRef({
    returnUrl: BASE_URL_SETTINGS,
  });
  window.location.assign(data.url);
};

export default goToBillingPortal;
